import React from 'react';
import { Link } from 'react-router';

import './app.component.css';

export default class AppComponent extends React.Component {
	render () {
		return (
			< div >
				< header className = "pg-hd" >
					< h1 className = "hd-tt" >有量开放平台< /h1 >
					< nav className = "hd-nv" >
						< ul className = "hd-nl" >
							< li className = "hd-ni" >
								< Link to = "/" >首页< /Link >
							< /li >
							< li className = "hd-ni" >
								< Link to = "/guide" >开发指南< /Link >
							< /li >
							< li className = "hd-ni" >
								< Link to = "/api" >API< /Link >
							< /li >
						< /ul >
					< /nav >
				< /header >

				< div className = "pg-bd" >
					< div className = "pg-mn" >
						{ this.props.children }
					< /div >
				< /div >

				< div className = "pg-ft" >
					< small className = "ft-cr" >2014 - 2016 wdwd.com 版权所有< /small >
				< /div >
			< /div >
		);
	}
};



/** WEBPACK FOOTER **
 ** ./app/app.component.js
 **/